import { render, staticRenderFns } from "./ShippingFee.pug?vue&type=template&id=ba895324&scoped=true&lang=pug&"
import script from "./ShippingFee.vue?vue&type=script&lang=js&"
export * from "./ShippingFee.vue?vue&type=script&lang=js&"
import style0 from "./ShippingFee.scss?vue&type=style&index=0&id=ba895324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba895324",
  null
  
)

export default component.exports